import React, { useEffect, useState } from 'react'
import { Stack, Typography, Container, Box } from '@mui/material'
import FilterPill from '../components/FilterPill'
import { useNavigate } from 'react-router'
import axios from '../services/axiosInstance'
import allZoneImage from '../assets/images/maps/all-zones.png' // Importing the logo image

const ZoneSelection = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [locationData, setLocationData] = useState([])

  useEffect(() => {
    const fetchLocationData = async () => {
      try {
        setLoading(true)
        const response = await axios.get('/application/get-location-master-data')
        const tempLocationData = response.data.data
        const updatedLocationData = {
          ...tempLocationData,
          zones: tempLocationData.zones.map(zone => ({
            ...zone,
            key: zone.name.toLowerCase()
          }))
        }
        console.log(updatedLocationData)
        setLocationData(updatedLocationData)
        window.localStorage.setItem('locationData', JSON.stringify(updatedLocationData))
      } catch (error) {
        console.error('Error fetching location data:', error)
        // notifications.show('Error occurred while verifying OTP', {
        //   severity: 'error',
        //   autoHideDuration: 3000
        // })
      } finally {
        setLoading(false)
      }
    }
    fetchLocationData()
  }, [])

  return (
    <Container maxWidth='lg' sx={{ my: 2 }}>
      {loading
        ? (
          <Typography
            variant='h6' color='text.secondary'
            sx={{ mt: 5, textAlign: 'center' }}
          >Loading...
          </Typography>
          )
        : (
          <>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              sx={(theme) => ({
                alignItems: theme.breakpoints.values.sm <= window.innerWidth ? 'center' : 'stretch',
                mb: 2
              })}
            >
              <Typography variant='med_28_500' sx={{ mr: 2 }}>Select Zone</Typography>
              <Typography>(Select the KEBEA Zone Based on Place of Working District, either in KPTCL or ESCOM's)</Typography>
            </Stack>
            <Stack
              direction='row'
              alignItems='center'
              spacing={2}
              sx={{
                overflowX: 'auto',
                whiteSpace: 'nowrap',
                pb: 1
              }}
            >
              <Box sx={{ position: 'absolute', left: 0, display: { md: 'none' }, fontSize: 22 }}> {'<'} </Box>
              {locationData.zones.map((individualZone) => (
                <FilterPill
                  key={individualZone.name}
                  label={individualZone.name}
                  onSelect={() => navigate(`/${individualZone.key}`)}
                />
              ))}
              <Box sx={{ position: 'absolute', right: 0, display: { md: 'none' }, fontSize: 22 }}> {'>'} </Box>
            </Stack>
            <Box
              sx={{

                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <Box
                component='img'
                src={allZoneImage}
                alt='Default Image'
                sx={{
                  maxWidth: '100%',
                  maxHeight: '75vh',
                  objectFit: 'contain'
                }}
              />
            </Box>
          </>
          )}
    </Container>

  )
}

export default ZoneSelection
